// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../common/Components/AgentProfilePhoto.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ChapterMembersListItem_agent_graphql = require("../../__generated__/ChapterMembersListItem_agent_graphql.bs.js");

let convertFragment = ChapterMembersListItem_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterMembersListItem_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function joinedText(date) {
  return "Joined " + (DateFns.formatDistance(date, new Date()) + " ago");
}

function ChapterMembersListItem(props) {
  let agent = RescriptRelay_Fragment.useFragment(ChapterMembersListItem_agent_graphql.node, convertFragment, props.agent);
  let getRegisteredAt = className => {
    let date = agent.registeredAt;
    if (date !== undefined) {
      return JsxRuntime.jsx("div", {
        children: joinedText(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(Primitive_option.valFromOption(date)))),
        className: TailwindMerge.twMerge([
          "text-gray-500",
          className
        ])
      });
    } else {
      return null;
    }
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(AgentProfilePhoto.make, {
          profilePhoto: agent.fragmentRefs
        }),
        className: "flex flex-col justify-center items-center"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: agent.displayName,
                  className: "font-medium text-lg text-gray-900"
                }),
                JsxRuntime.jsx("div", {
                  children: Stdlib_Option.getOr(agent.brokerage, ""),
                  className: ""
                }),
                getRegisteredAt("md:hidden my-4"),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    href: "/agents/" + agent.id,
                    size: "small",
                    icon: "user-profile",
                    children: "View " + (Stdlib_Option.getOr(agent.firstName, agent.displayName) + "'s profile")
                  }),
                  className: "mt-4"
                })
              ]
            }),
            getRegisteredAt("hidden md:block")
          ],
          className: "flex flex-col md:flex-row justify-between"
        }),
        className: "grow"
      })
    ],
    className: "flex flex-col md:flex-row border border-gray-300 p-4 gap-4 text-center md:text-left"
  });
}

let make = ChapterMembersListItem;

exports.AgentFragment = AgentFragment;
exports.joinedText = joinedText;
exports.make = make;
/* Scalars Not a pure module */
